export type ReviewOriginalPayload = {
  image_b64?: string;
  image_mime?: string;
  image_storage_path?: string;
};

export type ReviewOriginalPage = {
  path: string;
  url: string;
  isPdf: boolean;
};

/** Ricostruisce una pagina visualizzabile dal file conservato nella review. */
export function originalPageFromReviewPayload(
  payload: ReviewOriginalPayload,
  reviewId: string,
): ReviewOriginalPage | null {
  const raw = payload.image_b64?.trim();
  if (!raw) return null;
  const mime = payload.image_mime?.trim() || 'image/jpeg';
  const isDataUrl = raw.startsWith('data:');
  const isPdf = mime.toLowerCase().includes('pdf') || raw.toLowerCase().startsWith('data:application/pdf');
  return {
    path: payload.image_storage_path || `review-${reviewId}.${isPdf ? 'pdf' : 'jpg'}`,
    url: isDataUrl ? raw : `data:${mime};base64,${raw}`,
    isPdf,
  };
}
